module.exports = __webpack_public_path__ + "static/media/MASTER-BG-TEMPLATE.9a417b0b.jpg";